import { useEffect, useState, useLayoutEffect, useMemo, useCallback } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
  collection,
  getCountFromServer,
  getDocs,
  query,
  Timestamp,
  where,orderBy
} from "firebase/firestore";
import { dbFirestore } from "helper/config/firebase";
import { useNavigate } from "react-router-dom";
import RoutingPaths from "helper/routingPath";
import TableName from "helper/tableName/tableName";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import Moment from "react-moment";
import Dateformat from "helper/constant/timeFormat";
import "./index.css";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { toast, ToastContainer } from "react-toastify";
import WhatsAppConfig from "helper/config/whatsappConfig";



function Home() {
  const [studentsCount, setStudentsCount] = useState(null);
  const [teacherCount, setTeacherCount] = useState(null);
  const [batchCount, setBatchCount] = useState(null);
  const [expenseData, setExpenseData] = useState(null);
  const [currentMonthIncome, setCurrentMonthIncome] = useState(null);
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);
  const [studentsData, setStudentsData] = useState([]);
  const [lastMonthStudentSData, setLastMonthStudentsData] = useState([]);
  const [notPaidStudents, setnotPaidStudents] = useState([])

  // Message modal state
  const [messageModalVisible, setMessageModalVisible] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [messageText, setMessageText] = useState("");
  const [isSendingMessage, setIsSendingMessage] = useState(false);

  useEffect(() => {
    checkUserRole();
    regularStudentsCount();
    teachersCount();
    dueCurrentMonthStudentList();
    batchesCount();
    totalCurrentMonthSale();
    totalCurrentMonthIncome();
    dueLastMonthStudentsList();
    setNotPaidFeeList();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useLayoutEffect(() => {
    document.title = "Home"
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function countQuery(tableName) {
    const q = query(collection(dbFirestore, tableName));
    return q;
  }

  // MARK: checkUserRole
  function checkUserRole() {
    const userInfo = JSON.parse(localStorage.getItem("session"));

    setIsAdmin(userInfo.role === "admin");
  }

  const navigateAndScroll = useCallback((path) => {
    navigate(path);
    window.scrollTo(0, 0);
  }, [navigate]);

  const studentListPath = useCallback(() => navigateAndScroll(RoutingPaths.studentsList), [navigateAndScroll]);
  const teacherListPath = useCallback(() => navigateAndScroll(RoutingPaths.teachersList), [navigateAndScroll]);
  const batchesListPath = useCallback(() => navigateAndScroll(RoutingPaths.batchesList), [navigateAndScroll]);
  const expenseListPath = useCallback(() => navigateAndScroll(RoutingPaths.basicExpensesList), [navigateAndScroll]);

  const studentInfoPath = useCallback((studentModel) => () => {
    navigate(RoutingPaths.viewStudents, { state: studentModel });
    window.scrollTo(0, 0);
  }, [navigate]);

  //MARK: count the regular students count
  async function regularStudentsCount() {

    const q = query(collection(dbFirestore, TableName.students), where("status", "==", "active"));
    const snapshot = await getCountFromServer(q);
    setStudentsCount(snapshot.data().count);
  }

  //MARK: count the teacher count
  async function teachersCount() {
    const q = query(collection(dbFirestore, TableName.teachers), where("status", "==", "active"));

    const snapshot = await getCountFromServer(q);
    setTeacherCount(snapshot.data().count);
  }

  //MARK: count the batch count
  async function batchesCount() {
    const q = countQuery(TableName.batches);

    const snapshot = await getCountFromServer(q);
    setBatchCount(snapshot.data().count);
  }

  //MARK:  the regular students list fetch and show data whose amount is pending
  async function dueCurrentMonthStudentList() {
    const dates = datesAccToMonth(0);

    let studentQuery = query(
      collection(dbFirestore, TableName.students),
      where("admission_date_timestamp", ">=", dates.start_date),
      where("admission_date_timestamp", "<=", dates.end_date),where('status', '==', "active"),
      orderBy("admission_date_timestamp", "desc"),
    );
    const querySnapshot = await getDocs(studentQuery);

    setFeeList(querySnapshot, dates);
  }

  function addDays(date, days) {
    const newDate = new Date(date);
    newDate.setDate(date.getDate() + days);
    return newDate;
  }


  async function dueLastMonthStudentsList() {
    const startDate = moment().add(-1, 'months').startOf('month');

    // Get the current date
    const todayDate = new Date();

    // Number of days that we want to add to the current date
    const days = 10;

    // Function call to add days
    const endDate = addDays(todayDate, days)

    let startMilliSeconds = Timestamp.fromDate(
      startDate.toDate()
    ).toMillis();
    let endMilliSeconds = Timestamp.fromDate(
      endDate
    ).toMillis();
  
    let studentQuery = query(collection(dbFirestore, TableName.students),where('status', '==', "active"),
        orderBy("admission_date_timestamp", "desc"),
  );

    const querySnapshot = await getDocs(studentQuery);

    const feeArray = [];
    if (querySnapshot.docs.length > 0) {
      const lastMonthStudents = querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }));
      
      // Use for...of to properly handle async operations
      for (const student of lastMonthStudents) {
        let studentQuery = query(
          collection(dbFirestore, TableName.pendingFees),
          where('pending_amount', '>', 0),
          where('student_id', '==', student.id), 
          where("month_timestamp", ">=", startMilliSeconds),
          where("month_timestamp", "<=", endMilliSeconds)
        );

        const pendingQuerySnapshot = await getDocs(studentQuery);
        const pendingArray = pendingQuerySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }));
        
        if (pendingArray.length > 0) {
          const finalModel = {
            fees: pendingArray.length > 0 ? pendingArray[0] : null,
            ...student
          }

          feeArray.push(finalModel);
        }
      }
    }
    
    setLastMonthStudentsData(feeArray);

  }

  async function setFeeList(querySnapshot) {
    const feeArray = [];
    const currentMonth = new Date();
    if (querySnapshot.docs.length > 0) {
      const currentMonthStudents = querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }));
      
      // Use for...of to properly handle async operations
      for (const student of currentMonthStudents) {
        let studentQuery = query(
          collection(dbFirestore, TableName.pendingFees),
          where("month", "==", moment(currentMonth).format(Dateformat.MMYYYY)),
          where('pending_amount', '>', 0),
          where('student_id', '==', student.id),
        );

        const pendingQuerySnapshot = await getDocs(studentQuery);
        const pendingArray = pendingQuerySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }));

        if (pendingArray.length > 0) {
          const finalModel = {
            fees: pendingArray.length > 0 ? pendingArray[0] : null,
            ...student
          }

          feeArray.push(finalModel);
        }
      }
    }
    
    setStudentsData(feeArray);
  }


  async function setNotPaidFeeList() {
    const currentMonth = new Date();
    const currentMonthStr = moment(currentMonth).format(Dateformat.MMYYYY);
    
    console.log('Debug: Current month format:', currentMonthStr);

    let studentQuery = query(collection(dbFirestore, TableName.students),where('status', '==', "active"),
    orderBy("admission_date_timestamp", "desc"));
    const querySnapshot = await getDocs(studentQuery);

    console.log('Debug: Total active students found:', querySnapshot.docs.length);

    const feeArray = [];
    if (querySnapshot.docs.length > 0) {
      const allStudents = querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }));
      
      // Use for...of to properly handle async operations
      for (const student of allStudents) {
        let studentFeeQuery = query(
          collection(dbFirestore, TableName.fee), 
          where('student_id', '==', student.id), 
          where("month", "==", currentMonthStr)
        );

        const pendingQuerySnapshot = await getDocs(studentFeeQuery);
        if (pendingQuerySnapshot.docs.length === 0) {
          feeArray.push(student);
          console.log('Debug: Student without fee payment:', student.name || student.student_name);
        }
      }
    }
    
    console.log('Debug: Total students without fee payment:', feeArray.length);
    setnotPaidStudents(feeArray);
  }


  const renderStudentName = useCallback((studentModel) => {
    if (studentModel) {
      return (
        <span
          className="student-name-link"
          onClick={studentInfoPath(studentModel)}
        >
          {studentModel.name}
        </span>
      );
    }
    return "NA";
  }, [studentInfoPath]);

  const renderAdmissionDate = useCallback((studentModel) => {
    if (studentModel.rejoin_date === "Invalid date") {
      return <Moment format={Dateformat.DDMMYYYY}>{studentModel.admission_date}</Moment>;
    }

    if (studentModel.rejoin_date) {
      return <Moment format={Dateformat.DDMMYYYY}>{studentModel.rejoin_date}</Moment>;
    } else if (studentModel.admission_date) {
      return <Moment format={Dateformat.DDMMYYYY}>{studentModel.admission_date}</Moment>;
    }
    return "NA";
  }, []);

  const dueLastMonthDate = useCallback((studentModel) => {
    if (studentModel) {
      const fixDateForAllBrowsers = dateString => dateString.replace(/-/g, '/');
      const validDate = fixDateForAllBrowsers(studentModel.admission_date);
      const admissionDate = new Date(validDate);

      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth();
      const day = admissionDate.getDate();

      const fullDate = new Date(year, month, day);
      return moment(fullDate).format(Dateformat.DDMMYYYY);
    }
    return "NA";
  }, []);

  // message button - open modal
  const tapOnMessage = useCallback((studentModel) => () => {
    setSelectedStudent(studentModel);
    setMessageText("");
    setMessageModalVisible(true);
  }, []);

  // close message modal
  const hideMessageModal = useCallback(() => {
    setMessageModalVisible(false);
    setSelectedStudent(null);
    setMessageText("");
  }, []);

  // send WhatsApp message
  const sendWhatsAppMessage = useCallback(async () => {
    if (!messageText.trim()) {
      toast.error("Please enter a message");
      return;
    }

    if (!selectedStudent?.contact_no) {
      toast.error("Student contact number not available");
      return;
    }

    setIsSendingMessage(true);

    try {
      // Format phone number (remove spaces, dashes, and ensure it has country code)
      let phoneNumber = selectedStudent.contact_no.replace(/[\s-]/g, "");
      if (!phoneNumber.startsWith("91")) {
        phoneNumber = "91" + phoneNumber;
      }

      const encodedMessage = encodeURIComponent(messageText);
      const url = `${WhatsAppConfig.baseUrl}?number=${phoneNumber}&type=text&message=${encodedMessage}&instance_id=${WhatsAppConfig.instanceId}&access_token=${WhatsAppConfig.accessToken}`;

      await fetch(url, { mode: "no-cors" });

      toast.success("Message sent successfully!");
      hideMessageModal();
    } catch (error) {
      console.error("Error sending message:", error);
      toast.error("Failed to send message. Please try again.");
    } finally {
      setIsSendingMessage(false);
    }
  }, [messageText, selectedStudent, hideMessageModal]);

  // render message button
  const renderMessageButton = useCallback((studentModel) => {
    return (
      <Button
        type="button"
        className="lists__edit_button"
        onClick={tapOnMessage(studentModel)}
        tooltip="message"
        tooltipOptions={{ position: "bottom" }}
      >
        <span className="pi pi-comments"></span>
      </Button>
    );
  }, [tapOnMessage]);

  // MARK: current month date function
  function datesAccToMonth(number) {
    const currentMonthStartDate = moment().add(number, "months").startOf("month");
    const currentMonthEndDate = moment().add(number, "months").endOf("month");
    let startMilliSeconds = Timestamp.fromDate(
      currentMonthStartDate.toDate()
    ).toMillis();
    let endMilliSeconds = Timestamp.fromDate(
      currentMonthEndDate.toDate()
    ).toMillis();
    const obj = { start_date: startMilliSeconds, end_date: endMilliSeconds };
    return obj;
  }

  //MARK: count the current month expense
  async function totalCurrentMonthSale() {
    const dates = datesAccToMonth(0);

    let basicExpenseQuery = query(
      collection(dbFirestore, TableName.basicExpenses),
      where("expense_date_num", ">=", dates.start_date),
      where("expense_date_num", "<=", dates.end_date)
    );

    const querySnapshot = await getDocs(basicExpenseQuery);
    const totalBasicExpenseAmount = querySnapshot.docs.reduce(
      (total, currentValue) => (total = total + currentValue.data().amount_num),
      0
    );

    let salaryExpenseQuery = query(
      collection(dbFirestore, TableName.salaryExpenses),
      where("salary_date_num", ">=", dates.start_date),
      where("salary_date_num", "<=", dates.end_date)
    );

    const salaryExpenseQuerySnapshot = await getDocs(salaryExpenseQuery);

    const totalSalaryExpenseAmount = salaryExpenseQuerySnapshot.docs.reduce(
      (total, currentValue) => (total = total + currentValue.data().salary_num),
      0
    );

    const TotalExpense = totalBasicExpenseAmount + totalSalaryExpenseAmount

    setExpenseData(TotalExpense);
  }

  //MARK: count the current month income
  async function totalCurrentMonthIncome() {
    const dates = datesAccToMonth(0);

    let q = query(
      collection(dbFirestore, TableName.fee),
      where("month_timestamp", ">=", dates.start_date),
      where("month_timestamp", "<=", dates.end_date)
    );

    const querySnapshot = await getDocs(q);

    const totalIncome = querySnapshot.docs.reduce(
      (total, currentValue) => (total = total + currentValue.data().amount),
      0
    );
    setCurrentMonthIncome(totalIncome)
  }


  const DashboardCard = useMemo(() => ({ title, value, onClick, bgColor, textColor, borderColor }) => (
    <div className="col dashboard-col">
      <div className="card p-4 home__card" style={{ backgroundColor: bgColor, borderColor }}>
        <h3 className="dashboard-para" style={{ color: "black" }}>{title}</h3>
        <p className="dashboard-content" onClick={onClick} style={{ color: textColor }}>
          {value}
        </p>
      </div>
    </div>
  ), []);

  const getAmountBodyTemplate = useCallback((data) => {
    if (data === lastMonthStudentSData) return priceBodyTemplate1;
    if (data === notPaidStudents) return pendingAmountOfNotPaidStudents;
    return priceBodyTemplate;
  }, [lastMonthStudentSData, notPaidStudents]);

  const StudentTable = useMemo(() => ({ title, data, bgColor, borderColor, showDueDate = true, colClass = "col" }) => (
    <div className={colClass}>
      <div className="card p-4 home__card student-table" style={{ backgroundColor: bgColor, borderColor }}>
        <h3 className="dashboard-para mb-3" style={{ color: "black" }}>
          {title}
        </h3>
        <DataTable
          className="mb-3"
          value={data}
          scrollable
          scrollHeight="flex"
          style={{ maxHeight: 'calc(100vh - 200px)' }}
        >
          <Column
            field="name"
            header="Student Name"
            frozen
            body={renderStudentName}
            className="table__column__capital student_name_link"
          />
          <Column
            field="admission_date"
            header="Admission Date"
            frozen
            body={renderAdmissionDate}
          />
          <Column
            field="pending_amount"
            header="Pending Amount"
            body={getAmountBodyTemplate(data)}
          />
          {showDueDate && (
            <Column
              header="Due Date"
              body={dueLastMonthDate}
            />
          )}
          <Column
            header="Action"
            body={renderMessageButton}
          />
        </DataTable>
      </div>
    </div>
  ), [renderStudentName, renderAdmissionDate, dueLastMonthDate, getAmountBodyTemplate, renderMessageButton]);

  return (
    <main className="modules__main__div">
      <div className="col-12">
        <div className="card modules__card">
          {isAdmin && (
            <>
              <section className="p-fluid">
                <div className="row modules__row row__home_module">
                  <DashboardCard
                    title="No. of Students"
                    value={studentsCount}
                    onClick={studentListPath}
                    bgColor="#eafdf6"
                    textColor="#2ab276"
                    borderColor="#eafdf6"
                  />
                  <DashboardCard
                    title="No. of Teachers"
                    value={teacherCount}
                    onClick={teacherListPath}
                    bgColor="#bee4e7"
                    textColor="#53999f"
                    borderColor="#bee4e7"
                  />
                  <DashboardCard
                    title="No. of Batches"
                    value={batchCount}
                    onClick={batchesListPath}
                    bgColor="#f4e8ff"
                    textColor="#bf83fe"
                    borderColor="#f4e8ff"
                  />
                </div>
              </section>

              <section className="p-fluid">
                <div className="row modules__row row__home_module mt-5">
                  <DashboardCard
                    title="Current Month Expense"
                    value={`Rs ${expenseData?.toLocaleString()}`}
                    onClick={expenseListPath}
                    bgColor="#f5e3e4"
                    textColor="#ce777a"
                    borderColor="#f5e3e4"
                  />
                  <DashboardCard
                    title="Current Month Income"
                    value={`Rs ${currentMonthIncome?.toLocaleString()}`}
                    bgColor="#eafbff"
                    textColor="#32b2cd"
                    borderColor="#eafbff"
                  />
                </div>
              </section>
            </>
          )}

          {!isAdmin && (
            <section className="p-fluid mt-5">
              <div className="row modules__row row__home_module">
                <div className="col-6">
                  <DashboardCard
                    title="No. of Students"
                    value={studentsCount}
                    onClick={studentListPath}
                    bgColor="#eafdf6"
                    textColor="#2ab276"
                    borderColor="#eafdf6"
                  />
                </div>
              </div>
            </section>
          )}

          <section className="p-fluid">
            <div className="row modules__row row__home_module mt-5">
              <StudentTable
                title="List of Students Whose Last Month Fee Is Pending"
                data={lastMonthStudentSData}
                bgColor="#eee7f2"
                borderColor="#eee7f2"
                colClass="col-12"
              />
            </div>
            <div className="row modules__row row__home_module mt-5">
              <StudentTable
                title="List of Students Who Get Enrolled In Current Month"
                data={studentsData}
                bgColor="#f7f4f0"
                borderColor="#f7f4f0"
                showDueDate={false}
                colClass="col-12"
              />
            </div>
          </section>

          <section className="p-fluid">
            <div className="row modules__row row__home_module mt-5">
              <StudentTable
                title="List of Students Who Do Not Pay Fee In Current Month"
                data={notPaidStudents}
                bgColor="#fff2f2"
                borderColor="#fff2f2"
              />
            </div>
          </section>
        </div>
      </div>

      {/* WhatsApp Message Modal */}
      <Dialog
        header={`Send Message to ${selectedStudent?.name || "Student"}`}
        visible={messageModalVisible}
        style={{ width: "450px" }}
        onHide={hideMessageModal}
        footer={
          <div className="d-flex justify-content-end gap-2">
            <Button
              label="Cancel"
              icon="pi pi-times"
              onClick={hideMessageModal}
              className="list__reset_button"
            />
            <Button
              label={isSendingMessage ? "Sending..." : "Send"}
              icon="pi pi-send"
              onClick={sendWhatsAppMessage}
              disabled={isSendingMessage}
              className="list__filter_button"
            />
          </div>
        }
      >
        <div className="p-fluid">
          <div className="field">
            <label htmlFor="studentNumber" className="mb-2 d-block">
              <strong>Contact Number:</strong> {selectedStudent?.contact_no || "N/A"}
            </label>
          </div>
          <div className="field mt-3">
            <label htmlFor="message" className="mb-2 d-block">
              <strong>Message:</strong>
            </label>
            <InputTextarea
              id="message"
              value={messageText}
              onChange={(e) => setMessageText(e.target.value)}
              rows={5}
              placeholder="Type your message here..."
              autoResize
            />
          </div>
        </div>
      </Dialog>
      <ToastContainer />
    </main>
  );
}

export default Home;

const priceBodyTemplate = (regularStudents) => {
  return `Rs ${regularStudents.fees?.pending_amount?.toLocaleString() || '0'}`;
};

const priceBodyTemplate1 = (regularStudents) => {
  return `Rs ${regularStudents.fees?.pending_amount?.toLocaleString() || '0'}`;
};

const pendingAmountOfNotPaidStudents = (regularStudents) => {
  return `Rs ${regularStudents.batch_fee_num?.toLocaleString() || '0'}`;
};
